<app-header class="header"></app-header>
<div class="page">
  <router-outlet></router-outlet>
</div>
<app-tab-bar class="tab-bar"></app-tab-bar>
